import React from "react";
import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";

const norm = (s) => String(s ?? "").toLocaleLowerCase("tr-TR");
export const matches = (q, ...fields) => {
  const n = norm(q).trim();
  return !n || fields.some((f) => norm(f).includes(n));
};

export default function SearchBox({ value, onChange, placeholder = "Ara…", testId = "search-input", className = "" }) {
  return (
    <div className={`relative ${className}`}>
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
      <Input value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} data-testid={testId} className="h-10 pl-9 pr-8" />
      {value && (
        <button type="button" onClick={() => onChange("")} data-testid={`${testId}-clear`} aria-label="Temizle"
          className="absolute right-2 top-1/2 -translate-y-1/2 h-6 w-6 rounded-md hover:bg-accent inline-flex items-center justify-center text-muted-foreground">
          <X className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  );
}
